module.exports = __webpack_public_path__ + "fwm_h5/img/a2201guyuangao.ce249bc4.jpg";